import React from "react"
import { css, cx, keyframes } from "emotion"
import { colors } from "theme"

type LoadingProps = {
  className?: string
}

let root = css`
  label: loading-root;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 11;
  background: rgba(255, 255, 255, 0.5);
`

let spinnerAnimation = keyframes`
  to {
    transform: rotate(360deg);
  }
`

let spin = css`
  height: 48px;
  width: 48px;
  background: transparent;
  border-radius: 50%;
  border: 2px solid ${colors.primaryActive};
  border-top: 2.4px solid ${colors.primary};
  animation: ${spinnerAnimation} 600ms linear infinite;
`

function Loading(props: LoadingProps) {
  return (
    <div className={cx(root, props.className)}>
      <div className={spin} />
    </div>
  )
}

export default Loading
